import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getRegistries } from 'Data/api';
import { Container, Grid, Button, Typography } from '@mui/material';
import CircularLoader from 'Components/Loaders/CircularLoader';
import useGlobalState from 'Hooks/useGlobalState';
import mainStyles from 'Styles/mainStyles';
import { useTranslation } from 'react-i18next';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';



const ConfirmBuilding = (props) => {
	// const { deviceId } = useParams();
	const [state, dispatch] = useGlobalState();
	const navigate = useNavigate();
	const location = useLocation();
	const classes = mainStyles();
	const { t } = useTranslation();
	const [viewListBuildings, setViewListBuildings] = useState([]);

	useEffect(() => {
		console.log('ConfirmDevice - useEffect')
		const fetchData = async () => {
			let buildings = await getRegistries();
			setViewListBuildings(buildings);
		}
		fetchData();
		console.log(state.device, location)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleConfirm = () => {
		navigate('../addroomtitle')
	}
	return (state.device ? 
		<Container component="main" maxWidth="sm">
			<Grid container justifyContent={'center'} alignItems='center'>
				<div className={classes.onboardContainer}>
					<Typography variant="h4" className={classes.title}>{t('Angiv bygning for din sensor')}</Typography>
				</div>
				<div className={classes.onboardImageContainer}>
					<img src="/assets/building.png" alt="Bygning" className={classes.onboardImageSkyen} />
				</div>
				<div className={classes.onboardContainer}>
					<Typography variant="h5" className={classes.title}>{t('Sensoren er tildelt:')}</Typography>
				</div>
				<div className={classes.onboardContainer}>
					{/* <Typography variant="body1" className={classes.title}>{state.device.registry.name}</Typography> */}
					<Autocomplete
						disablePortal
						id="combo-box-demo"
						options={viewListBuildings}
						getOptionLabel={(option) => option.name + '(' + option.org.name + ')'}
						renderInput={(params) => <TextField {...params} label={state.device.registry.name + '(' + state.device.registry.org.name + ')'} />}
						onChange={(event, value) => {
							if (value) {
								console.log('Selected building:', value, state.device);
								// Here you can handle the selected building, e.g., update the device's registry
								state.device.registry = value; // Update the device's registry
								dispatch({ device: state.device }); // Update the global state
								// Handle the selected building here
							}
						}}
						style={{ width: '100%' }}
					/>
				</div>
				<div className={classes.onboardContainer}>
					<Typography variant="body2" className={classes.title}>{t('Tryk på knappen "Bekræft" hvis dette er den rette lokation eller på "Nej" hvis sensoren hænger på en anden lokation.')}</Typography>
				</div>

				<Button onClick={handleConfirm} variant="contained" className={classes.greenButton}>{t('Bekræft lokation')}</Button>
			</Grid>
		</Container>
		:
		<CircularLoader />
	)

}

export default ConfirmBuilding;